import { Box, Button, ButtonGroup, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useState } from "react";
import SelectBoxSearch from "src/shared/components/select_box_search";
import { Task } from "../../interface";

const FieldsViews = ({ task, listForConfig, onChange }: { task: Task | undefined, listForConfig: any, onChange: any }) => {
    const options: string[] = ["Nombre"];

    const [selectedOption, setSelectedOption] = useState(options[0]);
    const [inputValueFilter, setInputValueFilter] = useState<string>("");

    const handleSelectChange = (
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        setSelectedOption(event.target.value);
        setInputValueFilter("");
    };

    const handleFilterInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        setInputValueFilter(event.target.value);
    };

    return (
        <Grid container spacing={2}>
            {/* <Grid size={12}>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mt: 3,
                    }}
                >
                    <SelectBoxSearch
                        options={options}
                        selectedOption={selectedOption}
                        onOptionChangeSelectBox={handleSelectChange}
                        onValueChangeInput={handleFilterInput}
                        inputValue={inputValueFilter}
                    />

                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <Typography
                            variant="body1"
                            color="initial"
                            sx={{ mr: 2 }}
                        >
                            Ejecutado
                        </Typography>
                        <ButtonGroup
                            variant="outlined"
                            aria-label="Basic button group"
                        >
                            <Button>Todo</Button>
                            <Button>SI</Button>
                            <Button>NO</Button>
                        </ButtonGroup>
                    </Box>
                </Box>
            </Grid> */}
            {task && task?.fieldActivities?.length > 0 ? (
                <Grid size={12} className="table_reports">
                    <div className="header">
                        <div>Pozo</div>
                        <div>Cuadrilla</div>
                        <div>Ingenieros</div>
                        <div>Actividad</div>
                        <div>Comentario</div>
                        <div>Carta</div>
                        <div>Nivel</div>
                    </div>
                    {task.fieldActivities.map((fieldActivity, index) => (
                        <div className="body_list" key={index}>
                            {/* TODO VALIDATE */}
                            <div className="body_row">
                                <div>{fieldActivity.well}</div>
                                <div>{fieldActivity.squad}</div>
                                <div>{fieldActivity.engineers}</div>
                                <div>{fieldActivity.activity}</div>
                                <div>{fieldActivity.comment}</div>
                                <div>{fieldActivity.letter}</div>
                                <div>{fieldActivity.level}</div>
                            </div>
                        </div>
                    ))}
                </Grid>
            ):(
                <Grid size={12}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100px",
                        }}
                    >
                        <Typography variant="body1" color="initial">
                            No hay actividades
                        </Typography>
                    </Box>
                </Grid>
            )}

        </Grid>
    );
};

export default FieldsViews;
